import API from 'api'
import { Events } from 'minivents'
import { createContext } from 'preact'

export const SeamlyApiContext = createContext<API | null>(null)

export const SeamlyEventBusContext = createContext<Events | null>(null)
